import React, {Component} from 'react';
import LatestAppointment from './LatestAppointment';
import AllAppointment from './AllAppointments';
import ReferFriend from './ReferFriend';
import server from '../../server';

class Evolution extends Component{
    state = {
        referModal:false,
        latestAppointment: {},
        appointments: []
    }

    componentWillMount(){
        server.get("patients/" + server.user.id + "/appointments", (data) =>{
            console.log(data)
            this.setState({userData:server.user, appointments:data, latestAppointment:data[0]});
        });
    }

    toggleModal = () =>{
        this.setState({referModal:!this.state.referModal})
    }

    render(){
        return(
            <div style={{width: "100%"}}>
                <div class="col1-app">
                    <div class="col1-app__wrapper">
                        <div class="col1-list h-100p">
                            <div class="peers w-100p ai-c jc-sb content-header">
                                <div class="content-header__left mL-20">
                                    <div class="content-header__title">
                                        <h3 class="m-0">
                                            Evolução
                                        </h3>
                                    </div>
                                </div>
                                <button onClick={this.toggleModal} 
                                        class="open-modal btn btn-clear peers ai-c pX-5 pY-0 mB-5 bdrs-2 mR-5 cur-p c-client-default"
                                        type="button">
                                    <i class="fa fa-user-plus"></i>
                                    Indicar amigo
                                </button>
                            </div>                        
                            <div class="scrollable h-100p">                            
                                <LatestAppointment latestAppointment={this.state.latestAppointment}/>
                                <AllAppointment appointments={this.state.appointments} latestAppointment={this.state.latestAppointment}/>
                            </div>
                        </div>
                    </div>
                </div>
                <ReferFriend 
                    toggleModal={this.toggleModal} 
                    open={this.state.referModal}/>
            </div>
        )
    }
}

export default Evolution;


// WEBPACK FOOTER //
// ./src/pages/evolution/Evolution.js